const linkStyles = 'text-blue-600 hover:underline dark:text-blue-400';

export default linkStyles;
